export const isValidDate = (dateString: string) => {
    const date = new Date(dateString);
    return (
        !Number.isNaN(date.getTime()) &&
        date.getFullYear() >= 2000 &&
        date.getFullYear() <= 2035
    );
};
